import config from './config';
import createApplication from './app';

const run = createApplication(config);
run();
